import React, { useState } from "react";
import { useTab } from "../../../contexts/tab";
import { deleteIcon, editIcon } from "../../icon";
import CoreForm from "../forms/CoreForm";
import DeleteCoreModal from "../forms/DeleteCoreModal";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

export default function TabBodyCore() {
  const [{ tabData }, { setTabData }] = useTab();
  const [isOpen, setIsOpen] = useState(false);
  const [coreToEdit, setCoreToEdit] = useState(null);
  const [coreToDelete, setCoreToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  function handaleEdit(core) {
    setCoreToEdit(core);
    setIsOpen(true);
  }

  async function submitFormData(values) {
    // alert(JSON.stringify(values));

    try {
      const res = await fetch(basePath + "getFilteredCores", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });
      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      core: "",
    },
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  async function handleReset() {
    formik.resetForm({
      core: "",
    });

    setTabData(null);
    const restApi = "getCores";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  return (
    <div>
      <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
        <form
          className="flex gap-3 items-center"
          onSubmit={formik.handleSubmit}
        >
          <label>
            <span className="mr-3">Search:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.core}
              onChange={formik.handleChange}
              type="text"
              name="core"
              placeholder="Search Core"
            />
          </label>

          <button className="bg-white rounded-sm px-2 py-1" type="submit">
            Submit
          </button>
          <button
            onClick={handleReset}
            className="bg-white rounded-sm px-2 py-1"
            type="button"
          >
            Reset
          </button>
        </form>
        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => setIsOpen(true)}
            className="bg-orange text-white p-2 rounded-md"
          >
            Add Core
          </button>
        )}
      </div>

      {!tabData && <ShimmerTable />}
      {tabData && (
        <table className="dataTable">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Core</th>

              <th scope="col">Note</th>
              {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tabData.data.map(({ id, core, note }) => {
              return (
                <tr key={id}>
                  <td scope="col">{id}</td>
                  <td scope="col">{core}</td>
                  <td scope="col">{note}</td>
                  {activeUser?.user_permission <= 2 && (
                    <td scope="col">
                      <button
                        className="bg-green-600 p-2 rounded-md my-1"
                        onClick={() => {
                          handaleEdit({ id, core, note });
                        }}
                      >
                        {editIcon}
                      </button>
                      <button
                        className="p-2 rounded-md ml-2 bg-orange"
                        onClick={() => {
                          setCoreToDelete({ id, core });
                        }}
                      >
                        {deleteIcon}
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <CoreForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        coreToEdit={coreToEdit}
        setCoreToEdit={setCoreToEdit}
      />
      <DeleteCoreModal
        coreToDelete={coreToDelete}
        setCoreToDelete={setCoreToDelete}
      />
    </div>
  );
}
